var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kyc-full-risk-evaluation"},[_c('el-tree',{attrs:{"data":_vm.treeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }